/**
 * @desc 删除附件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.associatedFilesFacadeImpl.removeBySourceIdAndType.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/associatedFiles/removeBySourceIdAndType`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
